<template>
  <div class="back-top" v-show="isShow" @click="backTop" :style="'bottom:' + (bottom || '200px')">
    <i class="iconfont icon-icon_shequzhongxin_zhiding"></i>
  </div>
</template>
<script lang="ts" setup>
import { onMounted, ref } from 'vue'

defineProps<{
  bottom?: string
}>()
const isShow = ref(false)
onMounted(() => {
  // 控制按钮显示隐藏
  window.addEventListener('scroll', () => {
    if (window.scrollY > window.innerHeight) {
      isShow.value = true
    } else {
      isShow.value = false
    }
  })
})
const backTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  })
}
</script>
<style lang="less" scoped>
  .back-top {
    width: 42px;
    height: 42px;
    background: #ffffff;
    border-radius: 50%;
    box-shadow: 0px 3px 6px 0px rgba(0,0,0,0.09);
    position: fixed;
    right: 16px;
    bottom: 200px;
    text-align: center;
    line-height: 42px;
    z-index: 10;
    .iconfont{
      color: #171921;
      font-size: 20px;
    }
  }
</style>
